//dependencias
import React, { Component } from 'react';

//componentes
import FechaPlanificacion from './fechaPlanificacion'

class Index extends Component {

    render(){
        return(
            <div>
                <FechaPlanificacion />
            </div>
        );
    }

}
export default Index;